import React, { Fragment } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import moment from "moment";

export const ChatScreenTrack = (props) => {
  return (
    <Scrollbars style={{ width: "100%", height: 222 }}>
      <div className="display-chat-screen-two">
        {props.comment.map((comment, index) => (
          <Fragment key={index}>
            {props.auth.user.VendorUser._id === comment.initiator_id ? (
              <div className={"col-md-7 offset-md-5 p-0 mb-4"}>
                <div
                  className={
                    comment.initiator === "Admin"
                      ? "display-chat-screen-two-blue"
                      : comment.initiator === "User"
                      ? "display-chat-screen-two-gray"
                      : "display-chat-screen-two-orange"
                  }
                >
                  <p className={"color-black f12-400"}>{comment.text}</p>
                </div>
                <div className="text-right">
                  <span className="f10-500 text-gray">
                    {moment(comment.time).format("h:mm a, Do MMMM YYYY")}
                  </span>
                  <span className="f10-700"> | {comment.initiator}</span>
                </div>
              </div>
            ) : (
              <div className={"col-md-7 p-0 mb-4"}>
                <div
                  className={
                    comment.initiator === "Admin"
                      ? "display-chat-screen-two-blue"
                      : comment.initiator === "User"
                      ? "display-chat-screen-two-gray"
                      : "display-chat-screen-two-orange"
                  }
                >
                  <p className={"color-black f12-400"}>{comment.text}</p>
                </div>
                <div>
                  <span className="f10-500 text-gray">
                    {moment(comment.time).format("h:mm a, Do MMMM YYYY")}
                  </span>
                  <span className="f10-700">
                    {" "}
                    | <i className="fa fa-cog" aria-hidden="true"></i>{" "}
                    {comment.initiator}
                  </span>
                </div>
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </Scrollbars>
  );
};

export const ChatScreenIssuesTrack = (props) => {
  return (
    <Scrollbars style={{ width: "100%", height: 222 }}>
      <div className="display-chat-screen-two">
        {props.comment.map((comment, index) => (
          <Fragment key={index}>
            {console.log(comment)}
            {props.auth.user.VendorUser._id === comment.comment_initiator_id ? (
              <div className={"col-md-7 offset-md-5 p-0 mb-4"}>
                <div
                  className={
                    comment.initiator === "Admin"
                      ? "display-chat-screen-two-blue"
                      : comment.initiator === "User"
                      ? "display-chat-screen-two-gray"
                      : "display-chat-screen-two-orange"
                  }
                >
                  <p className={"color-black f12-400"}>{comment.content}</p>
                </div>
                <div className="text-right">
                  <span className="f10-500 text-gray">
                    {moment(comment.date).format("h:mm a, Do MMMM YYYY")}
                  </span>
                  <span className="f10-700">
                    {" "}
                    | {comment.comment_initiator}
                  </span>
                </div>
              </div>
            ) : (
              <div className={"col-md-7 p-0 mb-4"}>
                <div
                  className={
                    comment.initiator === "Admin"
                      ? "display-chat-screen-two-blue"
                      : comment.initiator === "User"
                      ? "display-chat-screen-two-gray"
                      : "display-chat-screen-two-orange"
                  }
                >
                  <p className={"color-black f12-400"}>{comment.content}</p>
                </div>
                <div>
                  <span className="f10-500 text-gray">
                    {moment(comment.date).format("h:mm a, Do MMMM YYYY")}
                  </span>
                  <span className="f10-700">
                    {" "}
                    | <i className="fa fa-cog" aria-hidden="true"></i>{" "}
                    {comment.comment_initiator}
                  </span>
                </div>
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </Scrollbars>
  );
};
